import {type ChangeEvent} from 'react'
import {useTranslation} from 'react-i18next'
import {trackEvent} from '../../../common/analytics/trackEvent'

interface IconTextStripProps {
  enabled: boolean
  textValue: string
  textColor: string
  stripColor: string
  onEnabledChange: (enabled: boolean) => void
  onTextChange: (value: string) => void
  onTextColorChange: (color: string) => void
  onStripColorChange: (color: string) => void
}

const IconTextStrip = ({
  enabled,
  textValue,
  textColor,
  stripColor,
  onEnabledChange,
  onTextChange,
  onTextColorChange,
  onStripColorChange,
}: IconTextStripProps) => {
  const {t} = useTranslation()

  return (
    <div className="icg-text-strip">
      <label className="icg-toggle">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onEnabledChange(e.target.checked)
            trackEvent('icon_text_strip_toggled', {enabled: e.target.checked})
          }}
        />
        <span>{t('iconGenerator.text.enable')}</span>
      </label>

      <input
        type="text"
        className="icg-text-input"
        value={textValue}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder={t('iconGenerator.text.placeholder')}
        disabled={!enabled}
        maxLength={24}
      />

      <div className="icg-row">
        <label className="icg-label">{t('iconGenerator.text.stripColor')}</label>
        <input
          type="color"
          className="icg-color-input"
          value={stripColor}
          onChange={(e) => onStripColorChange(e.target.value)}
          disabled={!enabled}
        />
      </div>

      <div className="icg-row">
        <label className="icg-label">{t('iconGenerator.text.textColor')}</label>
        <input
          type="color"
          className="icg-color-input"
          value={textColor}
          onChange={(e) => onTextColorChange(e.target.value)}
          disabled={!enabled}
        />
      </div>
    </div>
  )
}

export default IconTextStrip
